import React from 'react';
import { FormCheck } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { updateFilterPartial } from '../../actions/eventFiltersActions';
import { EventsFilter } from '../../interfaces';
import { selectFilters } from '../../selectors';
import { SavedSearchService } from '../../services';
import { Debounce, arrayToggle } from '../../utils';
import { ToggleButton as BaseToggleButton } from '../atoms';

interface Props {
  field: keyof EventsFilter;
  value: any;
  children: any;
  className?: string;
}

interface TogglableElementProps extends Props {
  field:
  | 'route_ids'
  | 'device_ids'
  | 'vehicle_ids'
  | 'selectedFilters'
  | 'vehicle_types'
  | 'active_lanes'
  | 'license_plates'
  | keyof EventsFilter;
}

const debouncer = new Debounce(500);

export function FilterRadioOption(props: Props) {
  const filter = useSelector(selectFilters);
  const dispatch = useDispatch<any>();

  const getCheckboxInputProps = () => {
    const { field, value, children } = props;
    const checked = filter[field] === value;
    const id = field + value;
    const label = children;
    return { value, checked, id, label, onChange: setStatusFilter };
  };

  const setStatusFilter = (e: any) => {
    const { field, value } = props;
    dispatch(updateFilterPartial({ [field]: value }));
    debouncer.debounce(() => {
      SavedSearchService.saveSearch(filter);
    });
  };

  return <FormCheck type="radio" {...getCheckboxInputProps()} className="hdn-radio-button" />;
}

export function ClearLink(props: Props) {
  const filter = useSelector(selectFilters);

  const dispatch = useDispatch<any>();

  const setStatusFilter = (e: any) => {
    let { value, field } = props;

    if (filter[field] === value) {
      value = undefined; // clear the value when clicking the same button again
    }

    e.preventDefault();
    e.stopPropagation();
    dispatch(updateFilterPartial({ [field]: value }));

    debouncer.debounce(() => {
      SavedSearchService.saveSearch(filter);
    });
  };

  return (
    <span {...props} onClick={setStatusFilter}>
      {props.children}
    </span>
  );
}

export function ToggleButton(props: TogglableElementProps) {
  const { value, field } = props;

  const dispatch = useDispatch<any>();
  const filter = useSelector(selectFilters);
  const selectedFilters = useSelector(selectFilters)[field] ?? [];

  const isEnabled = selectedFilters.includes(value);

  const toggleFilter = (identifier: string) => {
    const newSelectedFilters = arrayToggle(selectedFilters, identifier);

    dispatch(updateFilterPartial({ [field]: newSelectedFilters }));

    debouncer.debounce(() => {
      SavedSearchService.saveSearch(filter);
    });
  };

  return <BaseToggleButton
    role="radio"
    aria-checked={isEnabled}
    {...props}
    onClick={() => toggleFilter(value)}
    isEnabled={isEnabled}
  >
    {props.children}
  </BaseToggleButton>
}
